import { useEffect, useState } from 'react';
import { ClassificationItem } from '../../types/fundScreener.type';
import { getFundClassifications } from '../../api/fundScreener.api';
import { DEFAULT_CLASSIFICATIONS } from '../../constants/fundScreener/classification.constant';

// Fetches the real classification taxonomy for the given market. Returns
// just "All" until the fetch resolves.
export const useFundClassifications = (market: string, token: string) => {
  const [classifications, setClassifications] = useState<ClassificationItem[]>(
    DEFAULT_CLASSIFICATIONS,
  );

  useEffect(() => {
    getFundClassifications(market, token)
      .then((items) => {
        setClassifications([
          { value: 'ALL', label: 'All', activated: true },
          ...items.map((item) => ({ value: item.id, label: item.label, activated: false })),
        ]);
      })
      .catch((err) => console.error('Failed to fetch fund classifications', err));
  }, [market, token]);

  return classifications;
};
